import { render } from "./App.vue?vue&type=template&id=8a7a8106"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=8a7a8106&lang=scss"
script.render = render

export default script